import { getStore } from "app/store/store"
import { uiActionCreator } from "ui/store/actions"
import { isDarkThemeActive, setTheme } from "ui/tools/theme"
import { IUserInfo } from "user/model"
import { isSspUserSession } from "user/tools/permissions"
import { IUIConfiguration, IUIConfigurationColor } from "../model"
import { uiConfigurationRPO } from "../repository"
import { getUiConfigTranslationsForSspUser } from "./state"

export const getUiConfiguration = (): IUIConfiguration => getStore().getState().ui.config

export async function loadUIConfig(): Promise<IUIConfiguration> {
  try {
    const config = await uiConfigurationRPO.getConfiguration()
    setTheme(isDarkThemeActive(), config)
    return config
  } catch (error) {
    onLoadJSError()
    throw error
  }
}

export const getDarkOrLightColor = (isDark: boolean, color: IUIConfigurationColor): string =>
  `${isDark ? color.dark : color.light} !important`

export const setIsSavingUiConfig = (isSaving: boolean) =>
  getStore().dispatch(uiActionCreator.setIsSavingConfig(isSaving))

export const setIsUiConfigDarkPreview = (isDarkPreview: boolean) =>
  getStore().dispatch(uiActionCreator.setIsDarkPreview(isDarkPreview))

export const getCDNAbsoluteUrl = (relativePath: string, config?: IUIConfiguration): string => {
  if (relativePath.startsWith("/images/")) {
    return relativePath
  }
  return `${(config || getStore().getState().ui.config).cdnUrl}${relativePath}`
}

export const getPixelsFromRems = (rems: number): number =>
  parseInt(getComputedStyle(document.documentElement).fontSize, 10) * rems

export const getUiConfigLoginImageSrc = (): string | undefined => {
  const { darkUrl, lightUrl } = getStore().getState().ui.config.images.login
  if (isDarkThemeActive()) {
    return !darkUrl ? undefined : getCDNAbsoluteUrl(darkUrl)
  } else {
    return !lightUrl ? undefined : getCDNAbsoluteUrl(lightUrl)
  }
}

export const checkSspUserUiConfigTranslations = (userInfo: IUserInfo) => {
  if (isSspUserSession(userInfo)) {
    getStore().dispatch(uiActionCreator.setUiConfigTranslations(getUiConfigTranslationsForSspUser()))
  }
}
